import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ContractMaintenance } from '../models/contract-maintenance.model';
import {
  ContractAuditLogEntry,
  ContractPriceReview,
  ContractJob,
  CreateContractJob
} from '../models/contract-maintenance.model';

@Injectable({
  providedIn: 'root'
})
export class ContractMaintenanceService {
  private apiUrl = `${environment.apiUrl}/Contract`;

  // Jobs have their own controller: the contract PUT replaces the whole object and cannot
  // express adding or deleting a single job row.
  private jobsUrl = `${environment.apiUrl}/ContractJob`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<ContractMaintenance[]> {
    return this.http.get<ContractMaintenance[]>(this.apiUrl);
  }

  getById(id: string): Observable<ContractMaintenance> {
    return this.http.get<ContractMaintenance>(`${this.apiUrl}/${id}`);
  }

  getHistory(contractId: string): Observable<ContractAuditLogEntry[]> {
    return this.http.get<ContractAuditLogEntry[]>(`${this.apiUrl}/${contractId}/history`);
  }

  /** Price reviews for a contract, newest reviewed date first. */
  getPriceReviews(contractId: string): Observable<ContractPriceReview[]> {
    return this.http.get<ContractPriceReview[]>(`${this.apiUrl}/${contractId}/price-reviews`);
  }

  /** Priced jobs for a contract, oldest first. */
  getJobs(contractId: string): Observable<ContractJob[]> {
    return this.http.get<ContractJob[]>(`${this.jobsUrl}/contract/${contractId}`);
  }

  addJob(job: CreateContractJob): Observable<ContractJob> {
    return this.http.post<ContractJob>(this.jobsUrl, job);
  }

  updateJob(id: string, job: ContractJob): Observable<ContractJob> {
    return this.http.put<ContractJob>(`${this.jobsUrl}/${id}`, job);
  }

  deleteJob(id: string): Observable<void> {
    return this.http.delete<void>(`${this.jobsUrl}/${id}`);
  }

  create(contract: ContractMaintenance): Observable<ContractMaintenance> {
    return this.http.post<ContractMaintenance>(this.apiUrl, contract);
  }

  update(id: string, contract: ContractMaintenance): Observable<ContractMaintenance> {
    return this.http.put<ContractMaintenance>(`${this.apiUrl}/${id}`, contract);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}